export const CUSTOMER_SET_RUC_HAS_LEGAL_REPRESENTATIVE =
    "@CUSTOMER/SET_RUC_HAS_LEGAL_REPRESENTATIVE";
export const CUSTOMER_PATCH_BUSINESS = "@CUSTOMER/PATCH_BUSINESS";
export const CUSTOMER_PATCH_CONTACT = "@CUSTOMER/PATCH_CONTACT";
export const CUSTOMER_PATCH_NATURAL_PERSON = "@CUSTOMER/PATCH_NATURAL_PERSON";
